import { motion as m } from 'motion/react'

export const motion = m as any as {
  [K in keyof typeof m]: any
}
